export default "__VITE_ASSET__DKK6mHw8__"